// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/overview',
    name: 'Overview',
    component: layout,
    redirect: '/home/index',
    meta: {
      title: '概览',
      i18Key: 'router.user.overview.title',
      roles: [1],
      category: 'insight'
    },
    sort: 1,
    children: [
      {
        path: 'index',
        name: 'OverviewIndex',
        component: () => import('@/views/Overview/Index.vue'),
        meta: {
          title: '概览',
          i18Key: 'router.user.overview.index',
          roles: [1],
          headerConditions: ['brand', 'keyword', 'cycleType', 'location']
        }
      }
    ]
  },
  // 新概览页
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: layout,
    redirect: '/dashboard/index',
    hiddenInMenu: true,
    meta: {
      title: '概览',
      i18Key: 'router.user.overview.title',
      roles: [1],
      category: 'insight'
    },
    sort: 1,
    children: [
      {
        path: 'index',
        name: 'DashboardIndex',
        component: () => import('@/views/Dashboard/Index.vue'),
        meta: {
          title: '概览',
          i18Key: 'router.user.overview.index',
          roles: [1],
          headerConditions: ['brand', 'keyword', 'cycleType', 'location']
        }
      }
    ]
  }
]
export default routes
